import React from 'react'
import { Link } from 'gatsby';
import Container from './container'
import * as styles from './footer.module.css'

const d = new Date();
const currentYear = d.getFullYear();

const Footer = () => (
  <Container as="footer">
    <div className={styles.footerWrapper}>
      <small>&copy; Copyright {currentYear}, NI Store</small>
      <Link target='_blank' to='https://www.instagram.com/nintendo_india_store/'>
        <i className="fab fa-instagram instagram-icon"></i>
      </Link>
    </div>
  </Container>
)

export default Footer
